'use strict';

var getCombinedRenderValue = function (value) {
    var multipleValuesCombined = '';
    value.forEach(function (valueData, index) {
        multipleValuesCombined = multipleValuesCombined
            .concat(index === 0 ? valueData.label : ", " + (valueData.label));
    });
    return multipleValuesCombined;
};

var renderValueBasedOnLength = function (value, renderValue, placeholder) {
    var returnValue = 'select';
    if (value.length > 1) {
        returnValue = getCombinedRenderValue(value);
    }
    else if (value.length === 1) {
        returnValue = value[0].label;
    }
    else if (renderValue) {
        returnValue = renderValue.label;
    }
    else if (placeholder) {
        returnValue = placeholder;
    }
    return returnValue;
};

var callOnCloseIfOpen = function (setIsOpen, onClose, isOpen) {
    if (isOpen) {
        if (onClose) {
            onClose();
        }
        setIsOpen(false);
    }
};

var toggleSelect = function (setIsOpen, onOpen, onClose, isOpen) {
    if (!isOpen && onOpen) {
        onOpen();
    }
    else if (isOpen && onClose) {
        onClose();
    }
    setIsOpen(!isOpen);
};

exports.callOnCloseIfOpen = callOnCloseIfOpen;
exports.getCombinedRenderValue = getCombinedRenderValue;
exports.renderValueBasedOnLength = renderValueBasedOnLength;
exports.toggleSelect = toggleSelect;
